import { useState } from "react";
import { ApiService } from "../../../services/api.service";
import { contextSegments, FormMode } from "../../Controls/context-segments";
import { DynamicDetailsList } from "../../Controls/DetailsList/DynamicDetailsList";
import { columns } from "./tour-columns";
import { transferItems } from "./tour.dto";
import { ITourDocument } from "./tour.type";
import TourForm from "./TourForm";

interface IProps {}

const apiCalls: ApiService = ApiService.getInstance();

const Tour = (props: IProps) => {
  // Own state
  const [reload, setReload] = useState<boolean>(false);
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
  const [formMode, setFormMode] = useState<FormMode>(FormMode.create);
  const [selectedItem, setSelectedItem] = useState<ITourDocument | null>(null);

  const closeModal = async () => {
    setIsModalOpen(false);
    setSelectedItem(null);
    setFormMode(FormMode.create);
  };

  const openItem = async (itemId: number) => {
    //   Fetch selected item by id
    const res = await apiCalls.getSingleTour(itemId);
    if (res?.status === 200) {
      setSelectedItem(res.data);
      setFormMode(FormMode.view);
      setIsModalOpen(true);
    }
  };

  return (
    <>
      <TourForm
        isModalOpen={isModalOpen}
        formMode={formMode}
        selectedItem={selectedItem}
        setFormMode={setFormMode}
        closeModal={closeModal}
        setReload={setReload}
      />
      <DynamicDetailsList
        reload={reload}
        columns={columns}
        contextKey={contextSegments.tour.contextKey}
        title={contextSegments.tour.pluralName}
        transferItems={transferItems}
        setReload={setReload}
        showModal={() => setIsModalOpen(true)}
        openItem={openItem}
      />
    </>
  );
};

export default Tour;
